// Lazily/safely load expo-local-authentication. On a build that doesn't have
// this native module compiled in yet (e.g. an older installed dev client),
// the require() throws synchronously and we fall back to unavailable below.
let LocalAuthentication = null;
try {
  LocalAuthentication = require('expo-local-authentication');
} catch {
  LocalAuthentication = null;
}

export async function isBiometricAvailable() {
  if (!LocalAuthentication) return false;
  try {
    const hasHardware = await LocalAuthentication.hasHardwareAsync();
    const isEnrolled = await LocalAuthentication.isEnrolledAsync();
    return hasHardware && isEnrolled;
  } catch {
    return false;
  }
}

export async function authenticateWithBiometrics() {
  if (!LocalAuthentication) return false;
  try {
    const result = await LocalAuthentication.authenticateAsync({
      promptMessage: 'Unlock Horse Math',
      disableDeviceFallback: false,
    });
    return result.success;
  } catch {
    return false;
  }
}
